<template lang = "html">
  <div class="article">
    <div class="title">
      <h1>CONTENTS</h1>
    </div>
    <div class="newsContent">
      <articleCard
        v-for="{ id, name, date, img, content, moreInfo, tag, tag2 } in sortedList"
        v-if="id===article_id"
        :key="id"
        :id="id"
        :article_title = "name"
        :article_date = "date"
        :article_img = "img"
        :article_content = "content"
        :article_moreInfo = "moreInfo"
        :article_tag = "tag"
        :article_tag2 = "tag2"
      />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import articleCard from '@/components/articleCard.vue'
import newsArticle from '../api/news_article.js'

export default {
  components: {
    articleCard
  },

  name: 'ArticleCard',
  data() {
    return {
      article_id: this.id
    }
  },
  computed: {
    list: () => newsArticle.fetch(),
    sortedList: function () {
      // LodashのorderByメソッドを使用
      return _.orderBy(this.list, 'id', this.order ? 'asc' : 'desc')
    }
  },
  props: {
    id: Number
  }
}
</script>

<style lang="css" scoped>
.article {
  position: absolute;
  top: 75px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);

  margin: 50px 0 75px 0;
  padding: 25px;

  width: 65vw;

  /* background-color: #fff; */
  background: rgb(255, 255, 255, 0.9);
  /* opacity: 0.9; */
}

@media(max-width: 670px){
  .article {
    position: absolute;
    top: 75px;
    left: 50%;
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);

    margin: 50px 0 75px 0;
    padding: 25px;

    width: 95vw;

    /* background-color: #fff; */
    background: rgb(255, 255, 255, 0.9);
    /* opacity: 0.9; */
  }
}

.title {
  position: relative;
  margin: 15px 0;
}

.newsContent {
  position: relative;
  margin: 15px 0;
}

</style>
